export enum TaskDifficulty {
  Easy,
  Normal,
  Difficult,
  VeryDifficult,
}
